export const addSquare = square => {
  return {
    type: 'ADD_SQUARE',
    square
  }
}

export const addSquarePreview = square => {
  return {
    type: 'ADD_SQUARE_PREVIEW',
    square
  }
}

export const removeSquarePreview = id => {
  return {
    type: 'REMOVE_SQUARE_PREVIEW',
    id
  }
}

export const findNextSlide = id => {
  return {
    type: 'GOTO_SLIDE',
    id
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js